import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUser } from "@type/user";

// Define the initial state using that type
const initialState: IUser = {
  username: "",
  roles: [{ userGroup: "default", role: "none" }],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUserInfo(state, action: PayloadAction<Partial<IUser>>) {
      Object.assign(state, action.payload);
    },
  },
});

export const { updateUserInfo } = userSlice.actions;
export default userSlice.reducer;
